<div class="page-content-inner">
  <h1>Welcome to the System Admin page</h1>

  <p>You can navigate to a particular section by clicking the buttons below.</p>
  <div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="20px">
    <a mat-raised-button color="primary" [routerLink]="['cloudsim']">Cloudsim</a>
    <a mat-raised-button color="primary" [routerLink]="['elasticsearch']">Elasticsearch</a>
  </div>
</div>
